document.addEventListener('DOMContentLoaded', () => {

    const overlay = document.querySelector('[data-menu-overlay]');

    if (!overlay) {
        return;
    }

    let activeOpenButton = null;

    const mobileBreakpoint = window.matchMedia(
        '(max-width: 47.999rem)'
    );


    /*
     * =========================================================
     * UberMenu responsive toggle
     * =========================================================
     */

    const getUberToggle = () => {
        return overlay.querySelector(
            '.ubermenu-responsive-toggle'
        );
    };


    /*
     * =========================================================
     * Open UberMenu mobile menu
     * =========================================================
     */

    const openUberMenuMobile = () => {

        if (!mobileBreakpoint.matches) {
            return;
        }

        const toggle = getUberToggle();

        if (!toggle) {
            return;
        }

        /*
         * UberMenu's toggle controls its own responsive
         * state. Only trigger it if the menu is currently
         * collapsed.
         */
        const menu = overlay.querySelector('.ubermenu');

        if (
            menu &&
            menu.classList.contains(
                'ubermenu-responsive-collapse'
            )
        ) {
            toggle.click();
        }
    };


    /*
     * =========================================================
     * Close UberMenu mobile menu
     * =========================================================
     */

    const closeUberMenuMobile = () => {

        if (!mobileBreakpoint.matches) {
            return;
        }

        const toggle = getUberToggle();

        if (!toggle) {
            return;
        }

        const menu = overlay.querySelector('.ubermenu');

        if (
            menu &&
            !menu.classList.contains(
                'ubermenu-responsive-collapse'
            )
        ) {
            toggle.click();
        }
    };


    /*
     * =========================================================
     * Set initial UberMenu section
     * =========================================================
     *
     * Desktop only.
     *
     * If WordPress has marked a top-level menu item as current,
     * open that section.
     *
     * Otherwise fall back to Solutions.
     */

    const setInitialMenuSection = () => {

        /*
         * On mobile UberMenu manages its own submenu state.
         */
        if (mobileBreakpoint.matches) {
            return;
        }

        const menu = overlay.querySelector('.ubermenu');

        if (!menu) {
            return;
        }


        /*
         * Look for the top-level section WordPress considers
         * to be the current page / ancestor.
         */
        let targetItem = menu.querySelector(
            '.ubermenu-item-level-0.ubermenu-current-menu-item, ' +
            '.ubermenu-item-level-0.ubermenu-current-page-parent, ' +
            '.ubermenu-item-level-0.ubermenu-current-page-ancestor, ' +
            '.ubermenu-item-level-0.ubermenu-current-menu-ancestor'
        );


        /*
         * Homepage (or anything without a current section)
         * defaults to Solutions.
         */
        if (!targetItem) {
            targetItem = menu.querySelector(
                '.ubermenu-item-level-0.menu-solutions'
            );
        }

        if (!targetItem) {
            return;
        }


        /*
         * Remove UberMenu's current open state from any
         * other top-level items.
         */
        menu.querySelectorAll(
            '.ubermenu-item-level-0.ubermenu-active'
        ).forEach((item) => {

            item.classList.remove(
                'ubermenu-active'
            );

        });


        /*
         * Activate our target item.
         */
        targetItem.classList.add(
            'ubermenu-active'
        );


        /*
         * Keep aria-expanded in sync.
         */
        menu.querySelectorAll(
            '.ubermenu-item-level-0 > .ubermenu-target'
        ).forEach((target) => {

            target.setAttribute(
                'aria-expanded',
                'false'
            );

        });

        const targetLink = targetItem.querySelector(
            ':scope > .ubermenu-target'
        );

        if (targetLink) {
            targetLink.setAttribute(
                'aria-expanded',
                'true'
            );
        }
    };


    /*
     * =========================================================
     * Open menu
     * =========================================================
     */

    const openMenu = (openButton) => {

        activeOpenButton = openButton;


        /*
         * Desktop establishes the initial active mega-menu
         * section.
         */
        setInitialMenuSection();


        /*
         * Show our Filtronic overlay.
         */
        overlay.classList.add(
            'is-open'
        );

        overlay.setAttribute(
            'aria-hidden',
            'false'
        );

        openButton.setAttribute(
            'aria-expanded',
            'true'
        );

        document.documentElement.classList.add(
            'menu-is-open'
        );

        document.body.classList.add(
            'menu-is-open'
        );


        /*
         * On mobile let UberMenu open its own responsive menu.
         */
        openUberMenuMobile();


        /*
         * Focus close button after everything is visible.
         */
        const closeButton = overlay.querySelector(
            '[data-menu-close]'
        );

        if (closeButton) {
            closeButton.focus();
        }
    };


    /*
     * =========================================================
     * Close menu
     * =========================================================
     */

    const closeMenu = () => {

        /*
         * Close UberMenu first while the overlay is still
         * available/visible.
         */
        closeUberMenuMobile();


        /*
         * Move focus out of the overlay before hiding it
         * from assistive technology.
         */
        if (activeOpenButton) {
            activeOpenButton.focus();
        }


        overlay.classList.remove(
            'is-open'
        );

        overlay.setAttribute(
            'aria-hidden',
            'true'
        );


        document
            .querySelectorAll('[data-menu-open]')
            .forEach((button) => {

                button.setAttribute(
                    'aria-expanded',
                    'false'
                );

            });


        document.documentElement.classList.remove(
            'menu-is-open'
        );

        document.body.classList.remove(
            'menu-is-open'
        );

        activeOpenButton = null;
    };


    /*
    * =========================================================
    * Click events
    * =========================================================
    */

    document.addEventListener('click', (event) => {

        const openButton = event.target.closest(
            '[data-menu-open]'
        );

        const closeButton = event.target.closest(
            '[data-menu-close]'
        );


        /*
        * Open menu.
        */
        if (openButton) {

            event.preventDefault();

            openMenu(openButton);

            return;
        }


        /*
        * Close button.
        */
        if (closeButton) {

            event.preventDefault();

            closeMenu();

            return;
        }


        /*
        * =====================================================
        * Same-page anchor links
        * =====================================================
        *
        * Normal page links cause a navigation, so the menu
        * naturally disappears.
        *
        * Anchor links on the current page don't navigate away,
        * so explicitly close our overlay.
        */

        const menuLink = event.target.closest(
            '[data-menu-overlay] a'
        );

        if (!menuLink) {
            return;
        }

        const href = menuLink.getAttribute('href');

        /*
        * Ignore links without a destination and UberMenu
        * controls using a bare "#".
        */
        if (!href || href === '#') {
            return;
        }

        const url = new URL(
            menuLink.href,
            window.location.href
        );

        const isSamePage =
            url.origin === window.location.origin &&
            url.pathname === window.location.pathname &&
            url.search === window.location.search;

        const hasAnchor = Boolean(url.hash);


        /*
        * Same page + real anchor:
        * close the overlay and allow the browser's normal
        * anchor behaviour to continue.
        */
        if (isSamePage && hasAnchor) {
            closeMenu();
        }

    });


    /*
     * =========================================================
     * Escape
     * =========================================================
     */

    document.addEventListener('keydown', (event) => {

        if (
            event.key === 'Escape' &&
            overlay.classList.contains('is-open')
        ) {
            closeMenu();
        }
    });

});